import { env } from '@env';
import { httpUtil } from '@/framework';
import { GetCustomerChartRequest, GetCustomerTotalChartResponse } from './Types';

export const getCustomerRevenueChart = httpUtil.createHttpRequestMeta<
    GetCustomerChartRequest,
    GetCustomerTotalChartResponse
>({
    baseUrl: env.orgServer,
    path: '/customers/revenue-by-timeline',
    method: 'GET',
    authentication: 'bearer'
});
